export default {
	overflowHidden: {
		overflow: 'hidden'
	},
	marginTop: {
		marginTop: '20px'
	}
}